import { SIDEBAR_STATUS_TOGGLE, SIDEBAR_CLOSE } from '../actions/actions'

export default function auth(state = {}, action) {
  switch (action.type) {
    case SIDEBAR_STATUS_TOGGLE:
      return { isOpen: !state.isOpen }

    case SIDEBAR_CLOSE:
      return { isOpen: false }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/sidebar.js